import moment from 'moment-timezone'

export const untilStart = (start, withoutSuffix = true) => {
  const startMoment = moment(start).tz(moment.tz.guess())
  return startMoment.diff(moment()) < 0
    ? null
    : startMoment.fromNow(withoutSuffix)
}

export const fromNow = (date, withoutSuffix = false) => {
  return moment.tz(date, moment.tz.guess()).fromNow(withoutSuffix)
}

export default {
  untilStart,
  fromNow,
}
